import { footerColumns } from "@/mocks/heigua";

export default function Footer() {
  return (
    <footer className="bg-cream-200/70 pt-14 pb-8 text-ink-700">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-ember-500 text-cream-50">
                <i className="ri-water-flash-line text-lg" />
              </span>
              <span className="leading-none">
                <span className="block font-serif text-lg font-bold tracking-tight text-ink-950">吃瓜黑屋</span>
                <span className="block text-[10px] tracking-widest text-ink-600">GOSSIP VAULT</span>
              </span>
            </a>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-ink-600">
              吃瓜黑屋专注于整理内部爆料与独家内幕，把私密分享的隐藏内容安全归档，持续更新。加密专区之外的任何主张，都以站内留证为准。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white text-ink-700 hover:text-ember-600">
                <i className="ri-wechat-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white text-ink-700 hover:text-ember-600">
                <i className="ri-telegram-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white text-ink-700 hover:text-ember-600">
                <i className="ri-mail-line" />
              </span>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="md:col-span-2 lg:col-span-2">
              <h3 className="text-sm font-semibold text-ink-950">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a href="#vault" className="text-sm text-ink-600 hover:text-ember-600">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3 lg:col-span-1 md:hidden" />
          <div className="md:col-span-1 md:hidden" />
        </div>

        <div className="mt-12 rounded-xl bg-white/50 px-5 py-4 text-xs leading-relaxed text-ink-600">
          内容立场声明：吃瓜黑屋仅作素材归档与公开记录，不参与删帖、不接洽控评，亦不对任何第三方主张背书。仍在定性的瓜料以化名或代号呈现，完整素材加密存放并设有时效。
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-cream-300/70 pt-6 sm:flex-row">
          <p className="text-xs text-ink-600">© 2026 吃瓜黑屋 Gossip Vault · 保留所有权利</p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-ink-600">
            <a href="#" className="hover:text-ember-600">隐私说明</a>
            <a href="#" className="hover:text-ember-600">用户协议</a>
            <a href="#" className="hover:text-ember-600">内容立场</a>
            <a href="#top" className="flex items-center gap-1 hover:text-ember-600">
              回到顶部
              <i className="ri-arrow-up-line" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}